export function generateName(activityType: string): string {
    let hash = '';
    for (let i = 0; i < 3; i++) {
        // charCode is a random number in 0~35.
        const charCode = Math.floor(Math.random() * 36);
        hash += charCode < 10
            // if charCode is in 0~9, we convert it to digit string and add it to the last of hash string.
            ? charCode
            // if charCode is in 10~35, we convert it to lowercase letter string and add it to the last of hash string.
            // ASCII: 10+87=97 -> 'a'
            // ASCII: 35+87=122 -> 'z'
            : String.fromCharCode(charCode + 87);
    }

    return activityType + '-' + hash;
}

export function generateUniqueId(): string {
    return Math.random().toString(36).substr(2, 9);
}

export function encodeMangledSuffix(toEncode: string): string {
    return `__${toEncode}__`;
}

export function generateUniqueArtifactName(prefix: string, reservedArtifactNames: string[] = []): string {
    const prefixLowerCase = prefix.toLowerCase();
    const regex = new RegExp('^' + prefixLowerCase + '[0-9]+$');
    let maxNumber = 0;
    const findMaxNumber = (artifactName: string) => {
        if (artifactName?.toLowerCase()?.match(regex)) {
            const thisSuffix = Number.parseInt(artifactName.slice(prefix.length), 10);
            if (thisSuffix > maxNumber) {
                maxNumber = thisSuffix;
            }
        }
    };
    for (const artifactName of reservedArtifactNames) {
        findMaxNumber(artifactName);
    }
    return prefix.concat((maxNumber + 1).toString());
}
